import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { getAlbumItemWeblinkDownloadsAndViewsCount } from 'reactApp/modules/albums/albums.selector';
import { getHomeItemWeblinkDownloadsAndViewsCount } from 'reactApp/modules/home/home.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import type { RootState } from 'reactApp/store';
import type { PublicInfoPlace } from 'reactApp/ui/PublicInfoModal/PublicInfoModal.types';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

export const useCounter = (place: PublicInfoPlace, id: string, isAlbum: boolean) => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const selector = isAlbum ? getAlbumItemWeblinkDownloadsAndViewsCount : getHomeItemWeblinkDownloadsAndViewsCount;

    const counter = useSelector((state: RootState) => selector(state, id));

    useEffect(() => {
        if ((isPaidUser || isCorpUser) && id) {
            emitAnalyticEvent(AnalyticEventNames.PUBLIC_INFO_VIEWS);
            emitAnalyticEvent(AnalyticEventNames.PUBLIC_INFO_DOWNLOADS);
            sendDwh({
                eventCategory: ECategoryGa.features,
                action: 'downloads',
                dwhData: {
                    place,
                    count: counter.downloads,
                },
            });
            sendDwh({
                eventCategory: ECategoryGa.features,
                action: 'views',
                dwhData: {
                    place,
                    count: counter.views,
                },
            });
        }
    }, [isPaidUser, isCorpUser, place, id, counter.views, counter.downloads]);

    return counter;
};
